var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { align: "center" } }, [
    _c("h3", [_vm._v("Referencias a este documento")]),
    _c("span", [
      _vm._v(
        _vm._s(_vm.traducitTipoDocumentoEnPalabras(_vm.getData.tipoDocumento)) +
          " #" +
          _vm._s(_vm.getData.folio)
      )
    ]),
    _c("br"),
    _c("br"),
    _c("br"),
    _vm.datas
      ? _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "vs-table",
              {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var data = ref.data
                        return _vm._l(data, function(tr, indextr) {
                          return _c(
                            "vs-tr",
                            { key: indextr },
                            [
                              _c(
                                "vs-td",
                                {
                                  attrs: {
                                    data: data[indextr].tipoDocumentoReferencia
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      data[indextr].tipoDocumentoReferencia
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "vs-td",
                                {
                                  attrs: { data: data[indextr].folioReferencia }
                                },
                                [_vm._v(_vm._s(data[indextr].folioReferencia))]
                              ),
                              _c(
                                "vs-td",
                                {
                                  attrs: {
                                    data: data[indextr].tipoDocumentoReferencia
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      data[indextr].tipoDocumentoReferencia
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "vs-td",
                                {
                                  attrs: {
                                    data: data[indextr].tipoDocumentoReferencia
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      data[indextr].tipoDocumentoReferencia
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "vs-td",
                                {
                                  attrs: {
                                    data: data[indextr].tipoDocumentoReferencia
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      data[indextr].tipoDocumentoReferencia
                                    )
                                  )
                                ]
                              ),
                              data[indextr].fechaReferencia
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "vs-td",
                                        {
                                          attrs: {
                                            data: data[indextr].fechaReferencia
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              data[indextr].fechaReferencia
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [_c("vs-td", [_vm._v("No disponible")])],
                                    1
                                  )
                            ],
                            1
                          )
                        })
                      }
                    }
                  ],
                  null,
                  false,
                  2334290087
                )
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Numero")]),
                    _c("vs-th", [_vm._v("Tipo")]),
                    _c("vs-th", [_vm._v("Folio")]),
                    _c("vs-th", [_vm._v("Fecha")]),
                    _c("vs-th", [_vm._v("Observaciones")]),
                    _c("vs-th", [_vm._v("Acciones")])
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "vs-table",
              { attrs: { noDataText: "No existen registros asociados" } },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Numero")]),
                    _c("vs-th", [_vm._v("Tipo")]),
                    _c("vs-th", [_vm._v("Folio")]),
                    _c("vs-th", [_vm._v("Fecha")]),
                    _c("vs-th", [_vm._v("Observaciones")]),
                    _c("vs-th", [_vm._v("Acciones")])
                  ],
                  1
                ),
                _c("vs-tr", [_c("vs-td")], 1),
                void 0
              ],
              2
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }